export const SNOWPACK_PUBLIC_VERSION = "5.62.9";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;